import * as R from 'ramda';
import { useQuery } from '@cd/react-query';
import { postJSONPS } from '@cd/utils';
import { either } from '@cd/utils';

export default function useGetApp(id, dispatch) {
	const url = `/get/app/${id}`;

	return useQuery(['getApp', id], () =>
		postJSONPS('GET', url).then(
			either(e => {
				dispatch({ type: 'post error', e });
				throw new Error(e);
			}, R.identity)
		)
	);
}
